import algoliasearch from 'algoliasearch/lite';

const algolia = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID || '',
  process.env.REACT_APP_ALGOLIA_API_KEY || ''
);

export default algolia;
